var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTag = function SvgIconTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.875a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.159 1.49a1.75 1.75 0 0 0-.848-.043h-.004l-7.565 1.51a1 1 0 0 0-.785.785l-1.51 7.565v.004a1.75 1.75 0 0 0 .48 1.575l9.785 9.783a1.74 1.74 0 0 0 2.48 0l8.477-8.478a1.74 1.74 0 0 0 0-2.48l-9.783-9.783a1.75 1.75 0 0 0-.727-.438M4.788 4.788l6.777-1.353 9.516 9.517-8.13 8.129-9.516-9.516z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconTag;